<template>
  <Panel :isLoading="isLoading">
    <h2 slot="title">
      HH Compliance <span :class="`indicator ${avgCompliance}`"></span>
      <div style="display: flex; margin-left:auto;align-items:center;gap: 0.5rem">
        7 Days
        <el-switch v-model="use24Hrs" on-color="#333" off-color="#333" on-text="" off-text=""></el-switch>
        24 Hrs
      </div>
    </h2>
    <el-table :data="tableData">
      <el-table-column label="Moment" prop="moment"></el-table-column>
      <el-table-column label="Compliance" prop="compliance">
        <template scope="scope">
          <div v-if="scope.row.total === 0">
            ---
          </div>
          <div v-else>
            {{ scope.row.percent }}%
            <span class="complianceBreakdown">({{ scope.row.complete }}/{{ scope.row.total }})</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </Panel>
</template>

<script>
import moment from "moment";
import Panel from "./Panel.vue";

export default {
  name: "HandNygieneCompliance",
  props: ["filters"],
  watch: {
    filters() {
      this.getSummary();
    },
    use24Hrs() {
      this.getSummary();
    }
  },
  components: {
    Panel
  },
  data() {
    return {
      avgCompliance: 0,
      isLoading: true,
      tableData: [],
      use24Hrs: true
    };
  },
  methods: {
    async getSummary() {
      this.isLoading = true;
      const useNewEndpoints = await this.getFeatureFlag('IPAC_LEGACY_API_ROLLOUT');
      const url = useNewEndpoints ? `${window.CONFIG.legacy_facade_api}/handhygiene/settings?facId=1` : `${window.CONFIG.api}/handhygiene/settings?facId=1`
      const { moments } = await this.$http.get(url).then(response => response.body);

      const filters = {
        ...this.filters,
        start: moment()
          .subtract(7, "days")
          .toDate()
          .toString(),
        end: moment()
          .toDate()
          .toString(),
        active: true,
        hhOutcomeCriteria: this.$configStore.hhOutcomeCriteria(),
        groupBy: "moment",
        timeScale: "week",
        tz: Intl.DateTimeFormat().resolvedOptions().timeZone
      };
      filters.facilityIds = filters.facIds;
      delete filters.facIds;

      if (!filters.unitIds.length) {
        delete filters.unitIds;
      }
      if (this.use24Hrs) {
        filters.start = moment()
          .subtract(24, "hours")
          .toDate()
          .toString();
      }
      const response = await this.$http
        .get(`${window.CONFIG.hh_api}/summary`, { params: filters })
        .then(resp => resp.json())
        .catch(() => {
          return [];
        });

      const defaults = {
        missed: 0,
        incomplete: 0,
        complete: 0,
        total: 0,
        percent: 0
      };
      const mappedData = new Map(moments.map(m => [m, { moment: m, ...defaults }]));
      response.forEach(r => {
        let prevValue = mappedData.get(r.moment);
        let nextValue = {
          ...defaults,
          ...prevValue,
          ...{
            [r.status]: r.total,
            total: prevValue.total + r.total
          }
        };
        nextValue.percent = Math.round((nextValue.complete / nextValue.total) * 1000) / 10;
        mappedData.set(r.moment, nextValue);
      });
      this.tableData = [...mappedData.values()];
      const avg = this.tableData.reduce((acc, val) => acc + val.complete, 0) / this.tableData.reduce((acc, val) => acc + val.total, 0);
      if (Number.isNaN(avg) || avg < 0.5) {
        this.avgCompliance = "red";
      } else if (avg >= 0.8) {
        this.avgCompliance = "green";
      } else {
        this.avgCompliance = "yellow";
      }
      this.isLoading = false;
    }
  }
};
</script>

<style scoped>
.complianceBreakdown {
  color: grey;
}
.indicator {
  display: inline-block;
  height: 1rem;
  width: 1rem;
  border-radius: 1rem;
}
.yellow {
  background-color: #ffdf00;
  border: 1px solid #cdb300;
}
.green {
  background-color: #04e300;
  border: 1px solid #288b00;
}
.red {
  background-color: #ff0000;
  border: 1px solid #cd0000;
}
</style>
